import React, { useEffect, useRef, useState } from "react";
import useOnClickOutside from "use-onclickoutside";
import { label } from "../../../config/constants";
import { FORM_TABS, PALETTE_SETTINGS } from "../FormsConstant";

/**
 * Form background color picker (palette dropdown) for the form builder settings sidebar.
 * @param {Object} props
 * @param {Object} [props.formData] - Form metadata; `formBgColor` syncs the local picker state
 * @param {function(string, string): void} [props.onFormBgColorChange] - Called with bg color key and hex when user picks a color
 * @author Abhishek Dhillon
 * @component FormSettings
 */
const FormBackgroundColor = ({ formData, onFormBgColorChange }) => {
  const [bgColor, setBgColor] = useState(formData?.formBgColor || FORM_TABS?.SUBSECTIONS_OBJ?.bgColor);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const colorPickerRef = useRef(null);

  useEffect(() => {
    setBgColor(formData?.formBgColor || FORM_TABS?.SUBSECTIONS_OBJ?.bgColor);
  }, [formData?.formBgColor]);

  useOnClickOutside(colorPickerRef, () => setShowColorPicker(false));

  const handleBgColorChange = (selectedColor) => {
    setBgColor(selectedColor);
    onFormBgColorChange?.(FORM_TABS?.SUBSECTIONS_OBJ?.bgColorKey, selectedColor);
    setShowColorPicker(false);
  };

  const handleColorDisplayClick = () => {
    setShowColorPicker(!showColorPicker);
  };

  return (
    <div className='form-setting-item'>
      <div className='setting-label'>{label.FORM_BACKGROUND_COLOR}</div>
      <div className='setting-control'>
        <div className='color-picker-wrapper position-relative' ref={colorPickerRef}>
          <div className='color-display d-flex align-items-center' onClick={handleColorDisplayClick}>
            <div className='color-preview me-2 flex-shrink-0' style={{ backgroundColor: bgColor }}></div>
            <svg className={`dropdown-arrow flex-shrink-0 ${showColorPicker ? "rotated" : ""}`} width='16' height='16' viewBox='0 0 24 24'>
              <path d='M7 10l5 5 5-5z' fill='currentColor' />
            </svg>
          </div>

          {showColorPicker && (
            <div className='color-picker-dropdown position-absolute mt-2 p-3'>
              <div className='color-palette-grid'>
                {PALETTE_SETTINGS.palette.map((colorHex, index) => (
                  <div
                    key={index}
                    id={`form-settings-bg-color-palette-${index}`}
                    className={`palette-tile ${bgColor === colorHex ? "selected" : ""}`}
                    style={{ backgroundColor: colorHex }}
                    onClick={() => handleBgColorChange(colorHex)}
                    title={colorHex}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormBackgroundColor;
